
import { CollabCreateForm } from 'components/CollabCreate'

export default function RequestNewFullPage() {
  return (
      <CollabCreateForm
          defaultInitialInvite="standard-service"
      />
  )
}
